import { z } from 'zod';

// 基本的な病院情報のスキーマ
export const HospitalSchema = z.object({
  id: z.union([z.string(), z.number()]),
  name: z.string(),
  address: z.string().optional(),
  phone: z.string().optional(),
  website: z.string().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
  deleted_at: z.string().nullable().optional(),
});

export type Hospital = z.infer<typeof HospitalSchema>;

// 全病院取得レスポンスのスキーマ
export const GetAllHospitalsResSchema = z.array(HospitalSchema);
export type GetAllHospitalsRes = z.infer<typeof GetAllHospitalsResSchema>; 